import React from 'react';
import { Card, Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import GridContainer from '@navi/web-ui/lib/layouts/Grid/GridContainer/GridContainer';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import GridColumn from '@navi/web-ui/lib/layouts/Grid/GridColumn/GridColumn';
import cx from 'classnames';
interface IBankDetails {
  accountNumber: string;
  ifscCode: string;
  bankName: string;
}

const DEFAULT_TEXT = '--';

export default function BankDetails(props: IBankDetails) {
  const { accountNumber, ifscCode, bankName } = props;
  const maskedAccountNumber = accountNumber
    ? accountNumber?.slice(0, -4).replace(/./g, 'X') + accountNumber?.slice(-4)
    : '-';

  return (
    <GridContainer className={styles.bankDetail}>
      <GridContainer>
        <GridRow>
          <GridColumn md={12}>
            <Typography variant="h4">E-Nach Linked Bank Account</Typography>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn md={12}>
            <Card className={cx(styles.cardWrapper, 'rr-block ')}>
              <GridRow>
                <GridColumn item xs={4} className={styles.heading}>
                  {maskedAccountNumber}
                </GridColumn>
                <GridColumn item xs={4} className={styles.heading}>
                  {ifscCode || DEFAULT_TEXT}
                </GridColumn>
                <GridColumn item xs={4} className={styles.heading}>
                  {bankName || DEFAULT_TEXT}
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn item xs={4} className={styles.subtext}>
                  Account Number
                </GridColumn>
                <GridColumn item xs={4} className={styles.subtext}>
                  IFSC Code
                </GridColumn>
                <GridColumn item xs={4} className={styles.subtext}>
                  Bank Name
                </GridColumn>
              </GridRow>
            </Card>
          </GridColumn>
        </GridRow>
      </GridContainer>
    </GridContainer>
  );
}
